import { createApp } from "vue";
import App from "./App.vue";
import api from "./api/axios";
import router from "./router";
import store from "./store";
import "./styles/index.scss";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
const app = createApp(App);
// Axios请求
let $api = new api({});
app.config.globalProperties.$api = $api;
app.config.productionTip = false;
import dayjs from "dayjs";
app.config.globalProperties.$filters = {
  format(value) {
    if (value) {
      return dayjs(value).format("YYYY-MM-DD HH:mm:ss");
    } else {
      return "";
    }
  }
};
app.use(router);
app.use(ElementPlus);
app.use(Antd);
app.use(store);
app.mount("#app");
